import { postCoreDataSecurityAccessComparisonExportSlice } from './post';

export const { requestPostCoreDataSecurityAccessComparisonExport, resetPostCoreDataSecurityAccessComparisonExport } =
	postCoreDataSecurityAccessComparisonExportSlice.asyncActionCreators;
